/** @jsx jsx */
import { jsx } from '@emotion/core'
import api from 'api'
import { Button, Icon, Tooltip } from 'bold-ui'
import { MChatRiscoEnum } from 'graphql/types.generated'
import { useAtendimentoContext } from 'hooks/atendimento-context/useAtendimentoContext'
import { reportFormatDate, useHandleImpressao } from 'hooks/impressao/useHandleImpressao'
import { isEmpty } from 'lodash'

import { MChatRfAccordionSection } from '../../components/MChatRfAccordionSection'
import { MChatRfAccordionStepper } from '../../components/MChatRfAccordionStepper'
import { MChatRfAccordionSectionEnum } from '../../model-mChatRf'
import { convertMChatToPerguntaRespostaInput } from '../converter-mchat'
import { ImpressaoMchat, MChatViewModel } from '../model-mchat'

interface MChatViewProps {
  value: MChatViewModel
}

export function MChatView(props: Readonly<MChatViewProps>) {
  const { value } = props

  const {
    atendimentoProfissional: { id: atendProfId },
    cidadao: { id: cidadaoId },
  } = useAtendimentoContext()

  const { handleImpressaoPath, handleImpressaoError } = useHandleImpressao()

  const hasValuesMChat = !isEmpty(value)

  const handlePrint = (mchat: MChatViewModel) => {
    const input: ImpressaoMchat = {
      atendProfId: hasValuesMChat ? value.footerInfo.atendimentoProfissionalId : atendProfId,
      cidadaoId: cidadaoId,
      resultado: mchat.resultado,
      risco: mchat.risco,
      aplicacao: convertMChatToPerguntaRespostaInput(mchat),
    }

    handleImpressaoPath({
      apiPath: api.mchat.imprimirMChat,
      values: input,
      file: `MChat.pdf`,
      dateFormat: reportFormatDate,
    }).catch(handleImpressaoError)
  }

  return (
    <MChatRfAccordionSection
      section={MChatRfAccordionSectionEnum.MCHAT}
      value={value}
      hideDivider
      stepper={
        <MChatRfAccordionStepper
          showPendingIcon={!hasValuesMChat}
          showCheckIcon={hasValuesMChat}
          showConnector={value?.risco === MChatRiscoEnum.MEDIO}
          showInfoIcon={false}
        />
      }
      secondaryActions={
        <Tooltip text='Imprimir'>
          <Button type='button' kind='normal' skin='ghost' size='small' onClick={() => handlePrint(value)}>
            <Icon icon='printerOutline' />
          </Button>
        </Tooltip>
      }
    />
  )
}
